

import {
  CalcPriceRes, PriceCalculationList
} from '@/views/dashboard/service/subscribe-details/subscribe-details.service'
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    priceData: {
      type: Object as PropType<CalcPriceRes>,
      default: () => ({} as CalcPriceRes)
    }
  },

  setup (props) {
    const calculationList = computed(() => {
      return [props.priceData.package_price_calculation_list, props.priceData.price_calculation_list].filter(v => v?.length)
    })

    return {
      calculationList
    }
  }
})
